import type { Campaign } from '@/data'
import type { CampaignPayload } from './createCampaign'
import api from '..'

export interface UpdateCampaignPayload extends Partial<CampaignPayload> {
  campaign_templates?: { id: number; ordinal: number }[]
}

export async function updateCampaign(
  id: string,
  payload: UpdateCampaignPayload,
): Promise<Campaign> {
  const res = await api.put(`/campaigns/${id}`, payload)
  return res.data.data
}
